import { render, staticRenderFns } from "./ModalMain.vue?vue&type=template&id=22a0f456&"
import script from "./ModalMain.vue?vue&type=script&lang=js&"
export * from "./ModalMain.vue?vue&type=script&lang=js&"
import style0 from "./ModalMain.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports